// The MatchTracker shows only when the skin enables it (uiPersonalizationGeneral
// has the_sport_match_tracker with enabled: true) and only for the sports it
// has a dedicated scene for. Every other sport gets no MatchTracker at all
// (the hero / the TheSports widgets instead) until its scene is added here.
export const MATCH_TRACKER_SPORT_IDS = [
    '6046',                         // football: SoccerStadium
    '54094',                        // tennis: TennisStadium
    '265917',                       // table tennis: TableTennisArena
    '48242', '1149105', '1149097',  // basketball: BasketArena
    '154923',                       // darts: DartsArena
    '35232',                        // ice hockey: IceHockeyArena
    '154914',                       // baseball: BaseballArena
    '154830',                       // volleyball: VolleyArena
    '35709',                        // handball: HandballArena
    '389537',                       // Aussie rules: AussieRulesArena
];

export function hasMatchTracker(sportId, uiPersonalizationGeneral) {
    const enabled = Array.isArray(uiPersonalizationGeneral) &&
        uiPersonalizationGeneral.some(w => w && w.id === 'the_sport_match_tracker' && w.enabled === true);
    return enabled && sportId !== null && sportId !== undefined && MATCH_TRACKER_SPORT_IDS.includes(String(sportId));
}
